/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import moment from 'moment';

export default class TimetableWeek extends Component {
  @computed('structure.days.@each.periods')
  get startHour() {
    let firstHour = 99;
    this.get('structure.days').forEach(function (day) {
      if (day && day.get('periods')) {
        let periods = day.get('periods');
        let period = periods[0];
        if (isEmpty(period)) {
          return;
        }
        let hour = moment(period.get('startTime'), 'HH:mm').format('HH');
        if (parseInt(hour, 10) < firstHour) {
          firstHour = hour;
        }
      }
    });
    // Default to 9am if we haven't got any periods to display.
    return this.formatHour(firstHour === 99 ? 9 : Math.max(0, firstHour));
  }

  @computed('structure.days.@each.periods')
  get endHour() {
    let lastHour = 0;
    this.get('structure.days').forEach(function (day) {
      if (day && day.get('periods')) {
        let periods = day.get('periods');
        let period = periods.at(-1);
        if (isEmpty(period)) {
          return;
        }
        let endTime = moment(period.get('startTime'), 'HH:mm').add(
          period.get('duration'),
          'm',
        );
        let hour = parseInt(endTime.format('HH'), 10);
        if (endTime.format('mm') == '00') {
          hour--;
        }
        if (hour > lastHour) {
          lastHour = hour;
        }
      }
    });
    // Default to 4pm if we haven't got any periods to display.
    return this.formatHour(lastHour === 0 ? 16 : Math.min(23, lastHour));
  }

  @computed('startHour', 'endHour')
  get hours() {
    let hours = [];
    let hour = parseInt(this.startHour, 10);
    let end = parseInt(this.endHour, 10);
    while (hour <= end) {
      hours.push(this.formatHour(hour) + ':00');
      hour++;
    }
    return hours;
  }

  formatHour(hour) {
    return hour > 9 ? hour : '0' + hour;
  }
}
